export const METRICS_LIST_REQUEST = 'METRICS_LIST_REQUEST'
export const METRICS_LIST_SUCCESS = 'METRICS_LIST_SUCCESS'
export const METRICS_LIST_FAIL = 'METRICS_LIST_FAIL'